import * as types from '../constants'
import _ from 'lodash'
const initState = {
    feeds: [],
    feedInf: {},
    shipper: {}
}

export default function(state = initState, action) {
    switch (action.type) {
        case types.GET_LIST_ORDER_HISTORY:
            state.feeds = []
            state.feedInf = {}
            action.payload.forEach((item, i) => {
              state.feeds.push(item._id)
              state.feedInf[item._id] = item
            });
            return _.cloneDeep(state)
        case types.GET_ORDER_DETAIL:
            state.feedInf[action.payload._id] = action.payload
            return _.cloneDeep(state)
        case types.GET_SHIPPER_MOVING:
            state.shipper = action.payload
            return _.cloneDeep(state)
        default:
            return state;
    }
}
